import { Lock } from "lucide-react";
import { AreaLayout } from "@/components/AreaLayout";

const BLOQUES = [
  { t: "Mi decisión", d: "Qué cambio has decidido trabajar." },
  { t: "Paso acordado", d: "La acción concreta que te llevas de la sesión." },
  { t: "Qué ocurrió", d: "Qué pasó al intentar darlo y cómo te sentiste." },
  { t: "Qué necesito revisar", d: "Lo que quieres mirar en la siguiente sesión." },
];

export default function Seguimiento() {
  return (
    <AreaLayout>
      <p className="eyebrow mb-4">Seguimiento</p>
      <h1 className="font-display text-4xl text-[#102B5B] sm:text-5xl" style={{ fontWeight: 600 }} data-testid="seguimiento-title">
        Llega a tu sesión sabiendo qué quieres trabajar.
      </h1>
      <p className="mt-4 max-w-2xl text-lg text-[#343A46]">
        La base queda construida. El seguimiento privado completo requiere acceso individual y queda
        preparado para la siguiente versión.
      </p>

      <div className="mt-10 grid gap-5 sm:grid-cols-2">
        {BLOQUES.map((b, i) => (
          <div key={b.t} className="soft-card p-6" data-testid={`seguimiento-bloque-${i}`}>
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-[#171A20]">{b.t}</h2>
              <span className="inline-flex items-center gap-1.5 text-sm text-[#626B79]">
                <Lock size={14} /> Próximamente
              </span>
            </div>
            <p className="mt-2 text-base text-[#626B79]">{b.d}</p>
            <div className="mt-4 h-20 rounded-2xl border border-dashed border-[#D6DAE0] bg-[#F4F7FD]" />
          </div>
        ))}
      </div>
    </AreaLayout>
  );
}
